import {useEffect} from "react";
import {Listener, Signal} from "./Signals";

export function useSignal<T>(signal: Signal<T>, handler: Listener<T>, deps: any[] = []) {
	useEffect(() => {
		return signal.subscribe(handler);
	}, deps);
}